import BoostCommerceApi from '../api';
import {
  IActiveCollection, IGetProductsResultsQuery,
  IGetProductsResult,
  ISearchFilter,
  ISearchProviderConfig, ISearchAndFilterProduct, 
  ISearchAndFilterProductImage, ISearchAndFilterProductPrice,
  ISearchAndFilterProductVariant
} from '../../../types';
import standardisePrice from '../../../../../util/standardisePrice';
import mapFilters from '../helpers/mapFilters';
import sortMap from '../helpers/sortMap';

const GetProductResults = (config: ISearchProviderConfig, searchFilters: ISearchFilter[], activeCollection: IActiveCollection, query: IGetProductsResultsQuery): Promise<IGetProductsResult> => (new Promise<IGetProductsResult>((resolve) => {

  const response: IGetProductsResult = {
    records: 0,
    total: 0,
    raw: null,
    products: [],
    filters: []
  }

 
  let pageIndex = 1;
  if (config.rLoadMoreMode === 'paginate' && query.pageIndex) {
    pageIndex = query.pageIndex
  }

  let limit = config.rProductsPerPage;
  if (config.rLoadMoreMode === 'loadMore' && query.pageIndex) {
    limit = limit * query.pageIndex;
  }

  try {

    const params = {
      q: query.term ?? '',
      // eslint-disable-next-line camelcase
      // event_type: 'filter',
      // eslint-disable-next-line camelcase
      collection_scope: activeCollection.id ?? 0,
      // eslint-disable-next-line camelcase
      build_filter_tree: searchFilters.length > 0,
      limit: limit,
      page: pageIndex,
      ...query.sortKey && sortMap[query.sortKey] ? {
        sort: sortMap[query.sortKey],
      } : {},
    }

    // set filters
    searchFilters.forEach((filter) => {

      filter.options.forEach((option) => {

        if (['MULTI_OPTION', 'SINGLE_OPTION'].includes(filter.type)) {
          if (!option.selected) return

          if (!params[filter.identifier]) params[filter.identifier] = []

          params[filter.identifier].push(option.identifier)
        } else if (filter.type === 'RANGE') {

          if (!params[filter.identifier]) params[filter.identifier] = []

          params[filter.identifier].push(`${option.selectedMinimum}:${option.selectedMaximum}`)
        } else {
          throw new Error('Filter type not implemented');
        }
      })
    })

    BoostCommerceApi(config.apiKey, config.apiEndpoint).request('search', params).then((res) => {

      // Early resolve if we have no results
      if (typeof res.data === 'undefined') {
        resolve(response)
      }

      response.total = res.data.total_product
      response.records = res.data.products.length

      // Map filters for updates
      if (typeof res.data.filter !== 'undefined') {
        response.filters = mapFilters(res)
      }

      // Map products
      response.products = res.data.products.map((product) => {
        const priceMin = standardisePrice(product.price_min)
        const priceMax = standardisePrice(product.price_max)
        const originalPrice = product.compare_at_price_max ? standardisePrice(product.compare_at_price_max) : priceMax 
        return <ISearchAndFilterProduct>{
          id: product.id,
          name: product.title,
          handle: product.handle,
          tags: product.tags,
          meta: product.metafields,
          url: `https://${location.hostname}${window.location.port ? ':' + window.location.port : ''}/products/${product.handle}`,
          images: product.images_info.map((image): ISearchAndFilterProductImage => {
            return<ISearchAndFilterProductImage>{
              src: image.src
            }
          }),
          price: <ISearchAndFilterProductPrice>{
            priceMin,
            priceMax,
            finalPrice: priceMax,
            originalPrice
          },
          variants: product.variants.map((variant): ISearchAndFilterProductVariant => {
            return<ISearchAndFilterProductVariant>{
              id: variant.id
            }
          })
        }
      })

      resolve(response)
    })
  } catch (e) {
    console.error(e)
    resolve(response)
  }
}))

export default GetProductResults
